export default "__VITE_ASSET__2sv6lyQ8__"